import React from 'react'
import PropTypes from 'prop-types'

function OverviewPortfolioManagers({ portfolioManagers }) {
  const currentDate = new Date()
  const currentYear = currentDate.getFullYear()
  const defaultImg =
    'https://www.columbiathreadneedleus.com/binaries/content/gallery/cti-blog/imported/cti-blank-profile.jpg/cti-blank-profile.jpg'
  return (
    <div id="portfolio-managers" className="u-paddingTop3gu">
      <h3 className="u-marginBottom2gu">Portfolio Managers</h3>
      <div className={`Grid Grid--withGutter u-sm-flexCol`}>
        {portfolioManagers.map((manager, managerIndex) => {
          const width =
            portfolioManagers.length > 2 ? 'u-size4of12' : 'u-size6of12'
          return (
            <figure
              className={`u-flex u-md-flexCol u-sm-sizeFull ${width} u-marginTop2gu`}
              key={manager.name + managerIndex}
            >
              <div className="u-size1of2 u-md-size3of4 u-sm-size5of12">
                <img
                  className="u-sizeFull"
                  src={manager.photoURL ? manager.photoURL : defaultImg}
                  alt={manager.altText ? manager.altText : manager.name}
                />
              </div>
              <figcaption className="u-marginLeft4gu u-size1of2 u-md-marginLeft0 u-md-sizeFull u-sm-sizeFill">
                <h3 className="u-marginBottom2gu u-md-marginTop2gu u-textColorBrand">
                  {manager.name}
                </h3>
                <p className="u-marginBottom2gu u-textSizeMsrm1">
                  {manager.yrsOfExp &&
                    `Member of investment community since ${manager.yrsOfExp}`}
                </p>
                {!isNaN(currentYear - parseInt(manager.withFundYr)) && (
                  <p className="u-textSizeMsrm1">
                    {`Fund manager since ${manager.withFundYr}`}
                  </p>
                )}
              </figcaption>
            </figure>
          )
        })}
      </div>
    </div>
  )
}

OverviewPortfolioManagers.propTypes = {
  portfolioManagers: PropTypes.array,
}

export default OverviewPortfolioManagers
